module.exports = __webpack_public_path__ + "img/zk-icon-management-server.9939db8c.svg";